/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Big from 'big.js';
export var RoundingMode;
(function (RoundingMode) {
    RoundingMode[RoundingMode["RoundDown"] = 0] = "RoundDown";
    RoundingMode[RoundingMode["RoundHalfUp"] = 1] = "RoundHalfUp";
    RoundingMode[RoundingMode["RoundHalfEven"] = 2] = "RoundHalfEven";
    RoundingMode[RoundingMode["RoundUp"] = 3] = "RoundUp";
})(RoundingMode || (RoundingMode = {}));
export class BcMath {
    static factorialTemp = new Map();
    static combinationsTemp = new Map();
    static factorial(num) {
        const calcNum = num;
        if (num <= 1)
            return '1';
        if (BcMath.factorialTemp.has(calcNum))
            return BcMath.factorialTemp.get(calcNum);
        let result = new BcMath(num);
        while (num > 1) {
            num -= 1;
            if (BcMath.factorialTemp.has(num)) {
                result = result.mul(BcMath.factorialTemp.get(num));
                break;
            }
            result = result.mul(num);
        }
        if (Number(result.comp(1)) <= 0)
            result = new BcMath(1);
        BcMath.factorialTemp.set(calcNum, result.get());
        return result.get();
    }
    static combinations(n, k) {
        if (BcMath.combinationsTemp.has(`c${n}|${k}`))
            return BcMath.combinationsTemp.get(`c${n}|${k}`);
        const result = (n >= k)
            ? Number(BcMath.base(BcMath.factorial(n))
                .div(BcMath.base(BcMath.factorial(k)).mul(BcMath.factorial(n - k)))
                .get())
            : 0;
        if (Number.isNaN(result))
            throw new Error('result is NaN');
        BcMath.combinationsTemp.set(`c${n}|${k}`, result);
        return result;
    }
    static getSource = (num) => (num instanceof BcMath) ? num.value : num;
    static base(num) {
        return new BcMath(BcMath.getSource(num));
    }
    value;
    constructor(num) {
        this.value = new Big(num);
    }
    get() {
        return this.value.valueOf();
    }
    goldenFormat() {
        return this.value.round(2, RoundingMode.RoundDown).valueOf();
    }
    abs() {
        return new BcMath(this.value.abs());
    }
    comp(num) {
        return this.value.cmp(BcMath.getSource(num));
    }
    add(num) {
        return new BcMath(this.value.plus(BcMath.getSource(num)));
    }
    sub(num) {
        return new BcMath(this.value.minus(BcMath.getSource(num)));
    }
    mul(num) {
        return new BcMath(this.value.times(BcMath.getSource(num)));
    }
    div(num) {
        return new BcMath(this.value.div(BcMath.getSource(num)));
    }
    mod(num) {
        return new BcMath(this.value.mod(BcMath.getSource(num)));
    }
    round(dp, rm) {
        return new BcMath(this.value.round(dp, rm));
    }
    toFixed(digit) {
        return new BcMath(this.value.toFixed(digit));
    }
}
//# sourceMappingURL=index.js.map